import { render, staticRenderFns } from "./splb.vue?vue&type=template&id=7f627db3&"
import script from "./splb.vue?vue&type=script&lang=js&"
export * from "./splb.vue?vue&type=script&lang=js&"
import style0 from "./splb.vue?vue&type=style&index=0&id=7f627db3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports